import { initComponent } from './core/init-component.js'
import { gsap } from '../components/src/gsap.js'

initComponent('.js-media-with-text-anchor', section => {
  const closeBtn = section.querySelector('.js-media-with-text-anchor-close')
  const fullScreenBtn = section.querySelector('.js-media-with-text-anchor-fullscreen')
  const body = document.body
  const html = document.documentElement
  const hash = window.location.hash.replace('#', '')

  const preventScroll = () => {
    document.body.style.overflow = 'hidden'
  }

  const allowScroll = () => {
    document.body.style.overflow = ''
  }

  const scrollToSection = () => {
    const offset = 220
    const top = section.getBoundingClientRect().top + window.scrollY - offset

    setTimeout(() => {
      window.scrollTo({ top })
      body.style.opacity = '1'
      html.style.backgroundColor = '#ffffff'
    }, 300)

    setTimeout(preventScroll, 400)

    const wrapper =
      section.querySelector('.image-with-text__wistia') ||
      section.querySelector('.image-with-text__youtube') ||
      section.querySelector('.image-with-text__shopify-asset')

    if (wrapper) {
      wrapper.classList.add('video-fullscreen-anchor');
    }

    const video = wrapper?.querySelector('video');

    if (video) {
      const isIpadSafari = () => {
        const ua = navigator.userAgent;
        const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
        return isIOS && isSafari;
      };

      const markReady = () => {
        if (isIpadSafari()) {
          setTimeout(() => {
            wrapper.classList.add('video-ready');
          }, 1000);
        } else {
          wrapper.classList.add('video-ready');
        }
      };

      if (video.readyState >= 2 || !video.autoplay) {
        markReady()
      } else {
        video.addEventListener('loadeddata', markReady, { once: true });
        video.addEventListener('canplay', markReady, { once: true });
      }
    }

    const overlay = section.querySelector('.js-media-with-text-anchor-overlay')
    if (overlay) {
      overlay.classList.add('active')
    }
  }

  if (hash) {
    if (section.id !== hash) {
      setTimeout(() => {
        body.style.opacity = '1'
        html.style.backgroundColor = '#ffffff'
      }, 50)
    } else {
      requestAnimationFrame(scrollToSection)
      window.scrollTo(0, 0)
    }
  } else {
    body.style.opacity = '1'
    html.style.backgroundColor = '#ffffff'
  }

  closeBtn?.addEventListener('click', () => {
    allowScroll()

    const wrapper = section.querySelector('.video-fullscreen-anchor')
    if (!wrapper) return

    const overlay = section.querySelector('.js-media-with-text-anchor-overlay')

    const target = section.querySelector('.image-with-text__media')

    overlay?.classList.remove('active')
    if (!target) {
      wrapper.classList.remove('video-fullscreen-anchor')
      return
    }

    const rect = target.getBoundingClientRect()

    const final = {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height
    }

    gsap.to(wrapper, {
      duration: 0.5,
      top: final.top,
      left: final.left,
      width: final.width,
      height: final.height,
      ease: 'power2.inOut',
      onComplete() {
        wrapper.classList.remove('video-fullscreen-anchor')
        wrapper.style.top = ''
        wrapper.style.left = ''
        wrapper.style.width = ''
        wrapper.style.height = ''
        wrapper.style.position = ''
        wrapper.style.zIndex = ''

        overlay?.classList.remove('active')
      }
    })
  })

  fullScreenBtn?.addEventListener('click', () => {
    preventScroll()

    const wrapper =
      section.querySelector('.image-with-text__wistia') ||
      section.querySelector('.image-with-text__youtube') ||
      section.querySelector('.image-with-text__shopify-asset')

    if (!wrapper) return


    const overlay = section.querySelector('.js-media-with-text-anchor-overlay')

    const rect = wrapper.getBoundingClientRect()

    gsap.set(wrapper, {
      position: 'fixed',
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height,
      zIndex: 99999
    })

    gsap.to(wrapper, {
      duration: 0.5,
      top: 0,
      left: 0,
      width: window.innerWidth,
      height: window.innerHeight,
      ease: 'power2.inOut',
      onComplete() {
        wrapper.classList.add('video-fullscreen-anchor')
        wrapper.classList.add('video-ready')
        wrapper.style.top = ''
        wrapper.style.left = ''
        wrapper.style.width = ''
        wrapper.style.height = ''

        overlay?.classList.add('active')
      }
    })
  })

  return { unload() { } }
})
